import { useMutation } from '@vue/apollo-composable'
import UpdateCustomersSpecialPriceMutation from '../graphql/UpdateCustomersSpecialPriceMutation.graphql'

export const useUpdateCustomerSpecialPrice = () => {
	const {
		mutate: updatePrice,
		loading,
		error,
		onDone,
		onError,
	} = useMutation(UpdateCustomersSpecialPriceMutation)

	const executeUpdate = async ({
		company_id,
		customer_id,
		stock_id,
		customers_price,
	}) => {
		try {
			const result = await updatePrice({
				company_id: company_id,
				customer_id,
				stock_id,
				customers_price,
			})
			return result
		} catch (err) {
			console.error('Error updating customer special price:', err)
			throw err
		}
	}

	return {
		executeUpdate,
		loading,
		error,
		onDone,
		onError,
	}
}
